import { render } from "./materialIcon3.vue?vue&type=template&id=12baf68d"
import script from "./materialIcon3.vue?vue&type=script&lang=js"
export * from "./materialIcon3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__